import z from 'zod';

const DateRange = z.object({
    start: z.coerce.date().optional(),
    end: z.coerce.date().optional(),
});

const BooleanFilter = z.preprocess((val) => {
    if (val === 'true') return true;
    if (val === 'false') return false;
    return undefined;
}, z.boolean().optional());

export const PayloadJobsSearchQuery = z.object({
    page: z.coerce.number().min(1).default(1),
    limit: z.coerce.number().min(1).max(100).default(20),

    taskSlug: z.array(z.string()).optional(),
    workflowSlug: z.array(z.string()).optional(),
    queue: z.array(z.string()).optional(),

    hasError: BooleanFilter,
    processing: BooleanFilter,
    completed: BooleanFilter,

    createdAt: DateRange.optional(),
    updatedAt: DateRange.optional(),
    completedAt: DateRange.optional(),
});

export type PayloadJobsSearchQuery = z.infer<typeof PayloadJobsSearchQuery>;
export type DateRangeFilter = z.infer<typeof DateRange>;
export type BooleanFilterType = z.infer<typeof BooleanFilter>;
